<script>
import List from '../../baseComponents/list'

export default {
	extends: List,
	data() {
		return {
			rowClick: (item) => {
				this.$router.push({ name: 'BotGroupsDetail', params: { id: item._id } })
			},
			items: [
				{ header: 'Nom', value: (item) => item.key, sort: 'name', filter: { name: 'name' } },
				{ header: 'Clef', value: (item) => item.key, sort: 'key', filter: { name: 'key' } },
			],
		}
	},
}
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/botGroups/botGroups.list.vue